import * as React from "react";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { HelmetProvider } from "react-helmet-async";
import { SnackbarProvider } from "notistack";
import dayjs from "dayjs";
import "dayjs/locale/en-gb";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { reactPlugin } from "../app-insights";
import { createCustomTheme } from "../themes/theme-factory";
import AxiosInterceptors from "../axios-interceptors";
import AuthProvider from "./auth-provider";
import CustomProviders from "./custom-providers";
import LongRunningTasksBackgroundNotifier from "../components/task/long-running-tasks-background-notifier";

export interface AppProvidersProps {
  children: React.ReactNode;
}

const theme = createCustomTheme();
dayjs.locale("en-gb");

const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <AuthProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
        <CustomProviders>
          <HelmetProvider>
            <AxiosInterceptors>
              <ThemeProvider theme={theme}>
                <AppInsightsContext.Provider value={reactPlugin}>
                  <SnackbarProvider maxSnack={3}>
                    <LongRunningTasksBackgroundNotifier />
                    {children}
                  </SnackbarProvider>
                </AppInsightsContext.Provider>
              </ThemeProvider>
            </AxiosInterceptors>
          </HelmetProvider>
        </CustomProviders>
      </LocalizationProvider>
    </AuthProvider>
  );
};

export default AppProviders;
